module.exports = __webpack_public_path__ + "img/upArrow.7884c85f.svg";